/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCollapsibleContent/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Children from 'Simple/Children'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TysiaCollapsibleContent({
  children,
  viewPath = "/DesignSystem/TysiaCollapsible/TysiaCollapsibleContent",
  isOpen
  
}) {
  return (<React.Fragment
>
<fromFlow.When is={isOpen}>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</fromFlow.When>
</React.Fragment>)
}